module.exports = __webpack_public_path__ + "static/media/tenenatInfoBack.b2b4d340.png";